import React from 'react';

import { AxiosResponse } from 'axios';
import { Dialog } from 'primereact/dialog';

import ConfirmationDialog from 'ui/shared/ConfirmationDialog';
import DeleteConfirmationDialog from 'ui/shared/DeleteConfirmationDialog';

import { Employee, GeographicalZone, TreeNode } from '../../types/interfaces';
import AddEmployeeCard from '../../ui/AddEmployeeCard';
import GeographicalZoneCard from '../../ui/GeographicalZoneCard';

import DeleteNodeDialog from './DeleteNodeDialog';


interface FunctionalStructureDialogsProps {
  dialogVisible: boolean;
  onHideEmployeeCard: () => void;
  addedEmployees: Employee[] | any[];
  employeeCardKey: string | number;
  onDirtyChange: (dirty: boolean) => void;
  updateTree: (selection: any) => void;
  closeEmployeeDialog: () => void;
  addEmployeeCardRef: any;
  parentKey?: string;

  isGeographicalZoneDialogVisible: boolean;
  onHideGeographicalZoneCard: () => void;
  selectedGeographicalZone: GeographicalZone;
  onGeographicalZoneUpdate: (
    id: number,
    updatedObject: GeographicalZone
  ) => Promise<AxiosResponse<any> | undefined>;
  onGeographicalZoneDelete: (
    id: number | string
  ) => Promise<void> | Promise<AxiosResponse<any> | undefined>;
  closeGeographicalZoneDialog: () => void;
  geographicalZoneCardRef: any;
  geographicalZoneReadOnly: boolean;

  deleteDialogVisible: boolean;
  onHideDeleteDialog: () => void;
  onConfirmDelete: () => void;
  selectedItem: TreeNode | null;

  showUnsavedDialog: boolean;
  onUnsavedCancel: () => void;
  onUnsavedContinue: () => void;
}

export function FunctionalStructureDialogs(
  props: FunctionalStructureDialogsProps
) {
  const {
    dialogVisible,
    onHideEmployeeCard,
    addedEmployees,
    employeeCardKey,
    onDirtyChange,
    updateTree,
    closeEmployeeDialog,
    addEmployeeCardRef,
    parentKey,

    isGeographicalZoneDialogVisible,
    onHideGeographicalZoneCard,
    selectedGeographicalZone,
    onGeographicalZoneUpdate,
    onGeographicalZoneDelete,
    closeGeographicalZoneDialog,
    geographicalZoneCardRef,
    geographicalZoneReadOnly,

    deleteDialogVisible,
    onHideDeleteDialog,
    onConfirmDelete,
    selectedItem,

    showUnsavedDialog,
    onUnsavedCancel,
    onUnsavedContinue
  } = props;

  return (
    <>
      <Dialog
        header="Добавить сотрудников"
        visible={dialogVisible}
        style={{
          minWidth: '697px',
          width: '697px',
          minHeight: '381px',
          height: '381px'
        }}
        maximizable
        modal
        onHide={onHideEmployeeCard}
      >
        <AddEmployeeCard
          addedEmployees={addedEmployees}
          key={employeeCardKey}
          onDirtyChange={onDirtyChange}
          updateTree={updateTree}
          closeDialog={closeEmployeeDialog}
          ref={addEmployeeCardRef}
          withoutButtons={false}
          parentKey={parentKey}
        />
      </Dialog>

      <Dialog
        header="Карточка географической зоны"
        visible={isGeographicalZoneDialogVisible}
        style={{
          minWidth: '630px',
          width: '630px',
          minHeight: 'fit-content'
        }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
        maximizable
        modal
        contentStyle={{ minHeight: '300px' }}
        onHide={onHideGeographicalZoneCard}
      >
        <GeographicalZoneCard
          geographicalZoneProps={selectedGeographicalZone}
          onUpdate={onGeographicalZoneUpdate}
          onDelete={onGeographicalZoneDelete}
          closeDialog={closeGeographicalZoneDialog}
          ref={geographicalZoneCardRef}
          readOnly={geographicalZoneReadOnly}
        />
      </Dialog>

      <DeleteConfirmationDialog
        visible={deleteDialogVisible}
        onHide={onHideDeleteDialog}
        onConfirm={onConfirmDelete}
        entityType="фактическую работу"
      >
        <DeleteNodeDialog selectedItem={selectedItem} />
      </DeleteConfirmationDialog>

      <ConfirmationDialog
        visible={showUnsavedDialog}
        onCancel={onUnsavedCancel}
        onContinue={onUnsavedContinue}
        message="Есть несохранённые изменения. Вы хотите продолжить без сохранения?"
      />
    </>
  );
}

